// Copyright 2017 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { IndexedDb, ObjectStoreDefinition } from "libraries/IndexedDb/IndexedDb";

@autoinject
export class SoramaPortalDb extends IndexedDb {
    public static MeasurementDeviceSetupStoreName = "MeasurementDeviceSetup";
    public static MeasurementStorageSyncStoreName = "MeasurementStorageSync";
    public static LocalImageStoreName = "LocalImages";
    public static LocalImageDataStoreName = "LocalImagesData";

    private static databaseName = "sorama-portal";
    private static databaseVersion = 5;
    private static storableObjectNames: ObjectStoreDefinition[] = [
        { name: SoramaPortalDb.MeasurementDeviceSetupStoreName, generateKey: true },
        { name: SoramaPortalDb.MeasurementStorageSyncStoreName, generateKey: true },
        { name: SoramaPortalDb.LocalImageStoreName, generateKey: true },
        { name: SoramaPortalDb.LocalImageDataStoreName, generateKey: false },
    ];

    constructor() {
        super(SoramaPortalDb.databaseName, SoramaPortalDb.databaseVersion, SoramaPortalDb.storableObjectNames);
    }

    protected beforeUpgrade(e: IDBVersionChangeEvent, db: IDBDatabase): void {}

    protected afterUpgrade(e: IDBVersionChangeEvent, db: IDBDatabase): void {}
}
